<script setup lang="ts">
interface Props {
  isDragging: boolean;
}

defineProps<Props>();
</script>

<template>
  <Teleport to="body">
    <div v-if="isDragging" class="drag-drop-overlay">
      <div class="drag-drop-content">
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.drag-drop-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(37, 99, 235, 0.1);
  backdrop-filter: blur(2px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none; /* allow drag events to pass through to the document */
}

.drag-drop-content {
  background: white;
  border: 2px dashed var(--primary-color);
  border-radius: 12px;
  padding: 48px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  max-width: 400px;
}
</style>
